import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';

import { TakeUntilDestroy } from '../../../../common/take-until-destroy.decorator';

// TODO modify cmps-tooltip in uikit to have this as an option
@Component({
    selector: 'cmps-ts-tooltip-conditional',
    template: ` <ng-container *ngIf="_show">
            <ng-content select="show"></ng-content>
        </ng-container>
        <ng-container *ngIf="!_show">
            <ng-content select="no-show"></ng-content>
        </ng-container>`,
    host: {
        '(mouseenter)': '_onMouseEnterLeave()',
        '(mouseleave)': '_onMouseEnterLeave()',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
@TakeUntilDestroy()
export class TooltipConditionalDirective
    implements OnInit, OnDestroy, TakeUntilDestroy
{
    @Input() selector: string;

    /** @private */
    _show: boolean;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _changeDetectorRef: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        //
    }

    ngOnDestroy(): void {
        //
    }

    /** @private */
    _onMouseEnterLeave(): void {
        const el: HTMLElement = this._el.nativeElement.querySelector(
            this.selector,
        );
        if (el == null) {
            this._show = false;
            return;
        }
        this._show =
            el.offsetWidth < el.scrollWidth ||
            el.offsetHeight < el.scrollHeight;
        this._changeDetectorRef.markForCheck();
    }
}
